const getExpiringSoon = () => {
    const ingredients = JSON.parse(localStorage.getItem("ingredients")) || [];
    const today = new Date();
    return ingredients.filter(ingredient => {
        const expDate = new Date(ingredient.expiration);
        const differenceInDays = (expDate - today) / (1000 * 60 * 60 * 24);
        return differenceInDays <= 3;
    });
};

const getLowStock = () => {
    const ingredients = JSON.parse(localStorage.getItem("ingredients")) || [];

    return ingredients.filter((ingredient) => {
        if (!ingredient || ingredient.amount === undefined || ingredient.minAmount === undefined) {
            return false; // Ochrana proti chybějícím nebo neplatným hodnotám
        }

        const amount = parseFloat(String(ingredient.amount).replace(",", "."));
        const minAmount = parseFloat(String(ingredient.minAmount).replace(",", "."));

        return !isNaN(amount) && !isNaN(minAmount) && amount < minAmount;
    });
};



export default { getExpiringSoon, getLowStock };
